import Link from 'next/link';

import { Box, Button, Divider, Paragraph, TextButton } from '@zillow/constellation-10';

import QueryConstants from '../../../srcLegacy/shared/constants/QueryConstants';
import { ROUTES } from '../../constants/urls';

const NoListings = ({ onLookUpListingsClick }: { onLookUpListingsClick: () => void }) => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <Box css={{ paddingTop: '600' }} />
      <Button tone="brand" emphasis="filled" css={{ marginBottom: '800' }} onClick={onLookUpListingsClick}>
        Find listings
      </Button>
      <Divider css={{ width: '124px', marginTop: 0, marginBottom: '1200', color: 'border.accent.yellow.hero' }} />
      <Box css={{ marginBottom: '200' }}>
        <Paragraph css={{ textAlign: 'center' }}>You can also create property listings on</Paragraph>
        <Paragraph css={{ textAlign: 'center' }}>Zillow by adding them manually.</Paragraph>
      </Box>
      <TextButton asChild>
        <Link href={{ pathname: ROUTES.PROPERTIES, query: { [QueryConstants.POSTING_PATH]: 'true' } }}>
          Add properties
        </Link>
      </TextButton>
    </Box>
  );
};

export default NoListings;
